import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getUserTradingAccounts } from "../../../redux/actions/adminActions";
import {
  filterAccountPlatform,
  filterAccountType,
  filterBaseCurrency,
} from "../../../config/constants";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, {
  selectFilter,
  textFilter,
} from "react-bootstrap-table2-filter";
import { Container, Row, Col, Spinner, Tabs, Tab } from "react-bootstrap";
import moment from "moment";

const TradingAccounts = props => {
  const [state, setState] = useState({
    editAccountErrors: "",
    showAccountModal: false,
    disableEditAccountBtn: false,
    selectedAccount: {},
    loading: true,
  });
  const [accountsLive, setLiveAccounts] = useState(null);
  const [usersLive, setLiveUsers] = useState(null);
  const [accountsDemo, setDemoAccounts] = useState(null);
  const [usersDemo, setDemoUsers] = useState(null);

  useEffect(() => {
    triggerGetAccounts();
  }, []);

  const triggerGetAccounts = () => {
    setState(prevState => {
      return {
        ...prevState,
        loading: true,
      };
    });
    getUserTradingAccounts("live", "approved")
      .then(res => {
        let users = {};
        res.data.users.map(user => (users[user._id] = user));
        setLiveUsers(users);

        setLiveAccounts(res.data.accounts);
        setState(prevState => {
          return {
            ...prevState,
            loading: false,
          };
        });
      })
      .catch(err => console.error(err));

    getUserTradingAccounts("demo", "approved")
      .then(res => {
        let users = {};
        res.data.users.map(user => (users[user._id] = user));
        setDemoUsers(users);

        setDemoAccounts(res.data.accounts);
      })
      .catch(err => console.error(err));
  };

  const customFilterCurrency = (filterVal, data) => {
    if (filterVal.length > 0) {
      return data.filter(user => user.baseCurrency === filterVal);
    }
    return data;
  };

  const customFilterAccountPlatform = (filterVal, data) => {
    if (filterVal.length > 0) {
      return data.filter(user => user.platform === filterVal);
    }
    return data;
  };

  const customFilterAccountType = (filterVal, data) => {
    if (filterVal.length > 0) {
      return data.filter(user => user.type === filterVal);
    }
    return data;
  };

  const columnsLive = [
    {
      dataField: "fullName",
      text: "FULL NAME",
      sort: true,
      classes: "breakWord",
      filter: textFilter({ placeholder: "Search..." }),
    },
    {
      dataField: "email",
      text: "EMAIL",
      sort: true,
      classes: "breakWord",
      filter: textFilter({ placeholder: "Search..." }),
    },
    {
      dataField: "type",
      text: "ACC. TYPE",
      sort: true,
      filter: selectFilter({
        options: filterAccountType,
        onFilter: customFilterAccountType,
      }),
    },
    {
      dataField: "number",
      text: "ACC. NUMBER",
      sort: true,
      filter: textFilter({ placeholder: "Search..." }),
    },
    {
      dataField: "platform",
      text: "PLATFORM",
      sort: true,
      filter: selectFilter({
        options: filterAccountPlatform,
        onFilter: customFilterAccountPlatform,
      }),
    },
    {
      dataField: "balance",
      text: "BALANCE",
      classes: "text-right",
      headerStyle: (col, colIndex) => {
        return { textAlign: "right" };
      },
      sort: true,
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        const numA = parseFloat(a);
        const numB = parseFloat(b);
        if (order === "asc") {
          return numB - numA;
        }
        return numA - numB; // desc
      },
      filter: textFilter({ placeholder: "Search..." }),
    },
    {
      dataField: "baseCurrency",
      text: "BASE CURRENCY",
      sort: true,
      filter: selectFilter({
        options: filterBaseCurrency,
        onFilter: customFilterCurrency,
      }),
    },
    {
      dataField: "timeCreated",
      text: "CREATED",
      sort: true,
    },
    {
      dataField: "timeApproved",
      text: "APPROVED",
      sort: true,
    },
  ];

  const columnsDemo = [
    {
      dataField: "fullName",
      text: "FULL NAME",
      sort: true,
      classes: "breakWord",
      filter: textFilter({ placeholder: "Search..." }),
    },
    {
      dataField: "email",
      text: "EMAIL",
      sort: true,
      classes: "breakWord",
      filter: textFilter({ placeholder: "Search..." }),
    },
    {
      dataField: "type",
      text: "ACC. TYPE",
      sort: true,
      filter: textFilter({ placeholder: "Search..." }),
    },
    {
      dataField: "number",
      text: "ACC. NUMBER",
      sort: true,
      filter: textFilter({ placeholder: "Search..." }),
    },
    {
      dataField: "platform",
      text: "PLATFORM",
      sort: true,
      filter: selectFilter({
        options: filterAccountPlatform,
        onFilter: customFilterAccountPlatform,
      }),
    },
    {
      dataField: "balance",
      text: "BALANCE",
      sort: true,
      classes: "text-right",
      sortFunc: (a, b, order, dataField, rowA, rowB) => {
        const numA = parseFloat(a);
        const numB = parseFloat(b);
        if (order === "asc") {
          return numB - numA;
        }
        return numA - numB; // desc
      },
    },
    {
      dataField: "baseCurrency",
      text: "BASE CURRENCY",
      sort: true,
      filter: selectFilter({
        options: filterBaseCurrency,
        onFilter: customFilterCurrency,
      }),
    },
    {
      dataField: "timeCreated",
      text: "CREATED",
      sort: true,
    },
    {
      dataField: "timeApproved",
      text: "APPROVED",
      sort: true,
    },
  ];

  const defaultSorted = [
    {
      dataField: "timeApproved",
      order: "asc",
    },
  ];

  let dataLive = [];
  if (!!accountsLive) {
    accountsLive.forEach((keyName, keyIndex) => {
      // Some data formatting before displaying
      if (Number.isInteger(accountsLive[keyIndex].timeCreated)) {
        accountsLive[keyIndex].timeCreated = moment(
          accountsLive[keyIndex].timeCreated * 1000
        )
          .format("YYYY/MM/DD HH:mm:ss")
          .toString();
      }

      if (Number.isInteger(accountsLive[keyIndex].timeApproved)) {
        accountsLive[keyIndex].timeApproved = moment(
          accountsLive[keyIndex].timeApproved * 1000
        )
          .format("YYYY/MM/DD HH:mm:ss")
          .toString();
      }

      accountsLive[keyIndex].balance = parseFloat(
        accountsLive[keyIndex].balance
      ).toFixed(2);

      if (usersLive && usersLive[accountsLive[keyIndex].userId]) {
        accountsLive[keyIndex].fullName = `${
          usersLive[accountsLive[keyIndex].userId].name
        } ${usersLive[accountsLive[keyIndex].userId].surname}`;
        accountsLive[keyIndex].email =
          usersLive[accountsLive[keyIndex].userId].email;
      }

      dataLive.push(accountsLive[keyIndex]);
    });
  }

  let dataDemo = [];
  if (!!accountsDemo) {
    accountsDemo.forEach((keyName, keyIndex) => {
      // Some data formatting before displaying
      if (Number.isInteger(accountsDemo[keyIndex].timeCreated)) {
        accountsDemo[keyIndex].timeCreated = moment(
          accountsDemo[keyIndex].timeCreated * 1000
        )
          .format("YYYY/MM/DD HH:mm:ss")
          .toString();
      }

      if (Number.isInteger(accountsDemo[keyIndex].timeApproved)) {
        accountsDemo[keyIndex].timeApproved = moment(
          accountsDemo[keyIndex].timeApproved * 1000
        )
          .format("YYYY/MM/DD HH:mm:ss")
          .toString();
      }

      if (usersDemo && usersDemo[accountsDemo[keyIndex].userId]) {
        accountsDemo[keyIndex].fullName = `${
          usersDemo[accountsDemo[keyIndex].userId].name
        } ${usersDemo[accountsDemo[keyIndex].userId].surname}`;
        accountsDemo[keyIndex].email =
          usersDemo[accountsDemo[keyIndex].userId].email;
      }

      dataDemo.push(accountsDemo[keyIndex]);
    });
  }

  return (
    <Container fluid>
      <Row>
        <Col>
          <h1 className="pt-3 px-3">
            Trading Accounts{" "}
            {state.loading ? <Spinner animation="border" /> : null}
          </h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <Tabs
            defaultActiveKey="live"
            transition={false}
            id="account-approved-tabs"
          >
            <Tab eventKey="live" title="LIVE" className="py-4">
              <BootstrapTable
                bootstrap4
                keyField="_id"
                data={dataLive}
                columns={columnsLive}
                defaultSorted={defaultSorted}
                hover={true}
                filter={filterFactory()}
                headerClasses="tableHeaderClass"
              />
            </Tab>
            <Tab eventKey="demo" title="DEMO" className="py-4">
              <BootstrapTable
                bootstrap4
                keyField="_id"
                data={dataDemo}
                columns={columnsDemo}
                defaultSorted={defaultSorted}
                hover={true}
                filter={filterFactory()}
                headerClasses="tableHeaderClass"
              />
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </Container>
  );
};

TradingAccounts.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  auth: state.auth,
  success: state.success,
  errors: state.errors,
});

export default connect(mapStateToProps)(TradingAccounts);
